import { render } from "./usergrantlistorderno.vue?vue&type=template&id=55c1eb3a"
import script from "./usergrantlistorderno.vue?vue&type=script&lang=js"
export * from "./usergrantlistorderno.vue?vue&type=script&lang=js"

import "./usergrantlistorderno.vue?vue&type=style&index=0&id=55c1eb3a&lang=less"
script.render = render

export default script